import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import { withClient } from '@deerplusofficial/pos-hoc';
import { createCancelToken, getResult } from '@deerplusofficial/pos-helper';
import withCreateOrder from './withCreateOrder';
import actions from '../../actions';

const { edit: editReceipt } = actions.receipt;
const { update: updatePayment } = actions.payment;

export default config => Component =>
  fp.compose(
    withClient(),
    withCreateOrder(),
    connect(
      null,
      { editReceipt, updatePayment }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithCreateOrderQrcode');

      componentWillUnmount() {
        !_.isUndefined(this.cancelCreateOrderQrcode) &&
          this.cancelCreateOrderQrcode();
      }

      onCreateOrderQrcode = async method_id => {
        const {
          onOrderCreate,
          editReceipt,
          updatePayment,
          client: { POSApi, onError },
        } = this.props;

        try {
          const { orderId, orderNumber } = await onOrderCreate();
          const {
            qrcode,
            payment: { id },
          } = getResult(
            await POSApi.get(`/orders/${orderId}/qrcode`, {
              params: { method_id },
              cancelToken: createCancelToken(this.cancelCreateOrderQrcode),
            })
          );

          editReceipt({ orderId, orderNumber });
          updatePayment({ qrcode, id });
        } catch (e) {
          onError(e);
        }
      };

      render() {
        return (
          <Component
            {...this.props}
            onOrderQrcodeCreate={this.onCreateOrderQrcode}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withCreateOrderQrcode.js